export default {
  widgets: {
    cardSelectionList: {
      title: 'Выбор карты',
      main: 'основное',
    },
  },
};
